import * as React from 'react';
import { ThunderboltFilled } from '@ant-design/icons';
import Tooltip from 'antd/lib/tooltip';
import { runwayColors } from './styles/globalStyles';

const AutomatedByRunwayIcon: React.FC = () => {
    return (
        <Tooltip title={'Automated by Runway'}>
            <ThunderboltFilled style={{ color: runwayColors.primary }} />
        </Tooltip>
    );
};

export default AutomatedByRunwayIcon;
